import { types } from 'mobx-state-tree'

const typeMap = {
  Button: () => require('../Button').default,
  Checkbox: () => require('../Checkbox').default,
  Container: () => require('../Container').default,
  Dropdown: () => require('../Dropdown').default,
  Embed: () => require('../Embed').default,
  Input: () => require('../Input').default,
  List: () => require('../List').default,
  ListItem: () => require('../ListItem').default,
  MenuGroup: () => require('../MenuGroup').default,
  Paragraph: () => require('../Paragraph').default,
  Radio: () => require('../Radio').default,
  Slider: () => require('../Slider').default,
  Sprite: () => require('../Sprite').default,
  Text: () => require('../Text').default,
  Title: () => require('../Title').default,
  Video: () => require('../Video').default,
  ButtonGroup: () => require('../ButtonGroup').default,
  CheckboxGroup: () => require('../CheckboxGroup').default,
  RadioGroup: () => require('../RadioGroup').default,
}

function dispatcher(snapshot) {
  const getType = typeMap[snapshot.Type]
  if (!getType) {
    throw new Error(`Unknown asset type: ${snapshot.Type}`)
  }
  return getType()
}

export default function() {
  return types.array(
    types.union(
      { dispatcher },
      types.late(() => require('../Button').default),
      types.late(() => require('../Checkbox').default),
      types.late(() => require('../Container').default),
      types.late(() => require('../Dropdown').default),
      types.late(() => require('../Embed').default),
      types.late(() => require('../Input').default),
      types.late(() => require('../List').default),
      types.late(() => require('../ListItem').default),
      types.late(() => require('../MenuGroup').default),
      types.late(() => require('../Paragraph').default),
      types.late(() => require('../Radio').default),
      types.late(() => require('../Slider').default),
      types.late(() => require('../Sprite').default),
      types.late(() => require('../Text').default),
      types.late(() => require('../Title').default),
      types.late(() => require('../Video').default),
      types.late(() => require('../ButtonGroup').default),
      types.late(() => require('../CheckboxGroup').default),
      types.late(() => require('../RadioGroup').default),
    )
  )
}

